// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-51ac1064]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.pass-tip[data-v-51ac1064] {\n  position: absolute;\n  bottom: 20px;\n}\n.error-bolder[data-v-51ac1064] .el-input__inner {\n  border-color: red;\n}", ""]);
// Exports
module.exports = exports;
